// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3zv0a","content":"styles_content__CNNBq","selectAll":"styles_selectAll__7r5k5"};